import { isDeviceError, isMeetingError } from '@stores/atoms/device';
import { isLoading } from '@stores/atoms/loading';
import { atom } from 'jotai';

export const modalLayoutState = atom<{
  loading: boolean;
  deviceError: boolean;
  meetingError: boolean;
}>((get) => {
  return {
    loading: get(isLoading),
    deviceError: get(isDeviceError),
    meetingError: get(isMeetingError),
  };
});
